import { API_URL, requestHeader } from '../constants/ApiConfiguration'

/** Ingredients */
export function fetchIngredients(pageToRequest = 1) {
    return fetch(API_URL + '/ingredients?page=' + pageToRequest, {
        method: 'GET', 
        headers: requestHeader()
    }).then(response => response.json()) 
}

export function searchIngredients(pageToRequest = 1, searchString = '') {
    return fetch(API_URL + '/ingredient-search?page=' + pageToRequest + '&search=' + searchString, {
        method: 'GET', 
        headers: requestHeader()
    }).then(response => response.json()) 
}

export function fetchIngredient(id) {
    return fetch(API_URL + '/ingredients/' + id, {
        method: 'GET', 
        headers: requestHeader()
    }).then(response => response.json()) 
}

// /** Tutorials */
// export function fetchTutorials(pageToRequest = 1) {
//     return fetch(API_URL + '/tutorials?page=' + pageToRequest, {
//         method: 'GET', 
//         headers: requestHeader()
//     }).then(response => response.json()) 
// }

// export function searchTutorials(pageToRequest = 1, searchString = '') {
//     return fetch(API_URL + '/tutorial-search?page=' + pageToRequest + '&search=' + searchString, {
//         method: 'GET', 
//         headers: requestHeader()
//     }).then(response => response.json()) 
// }

// export function fetchTutorial(id) {
//     return fetch(API_URL + '/tutorials/' + id, {
//         method: 'GET', 
//         headers: requestHeader()
//     }).then(response => response.json()) 
// }

// /** Techniques */
// export function fetchTechniques(pageToRequest = 1) {
//     return fetch(API_URL + '/techniques?page=' + pageToRequest, {
//         method: 'GET', 
//         headers: requestHeader()
//     }).then(response => response.json()) 
// }

// export function searchTechniques(pageToRequest = 1, searchString = '') {
//     return fetch(API_URL + '/techniques-search?page=' + pageToRequest + '&search=' + searchString, {
//         method: 'GET', 
//         headers: requestHeader()
//     }).then(response => response.json()) 
// }

// export function fetchTechnique(id) {
//     return fetch(API_URL + '/techniques/' + id, {
//         method: 'GET', 
//         headers: requestHeader()
//     }).then(response => response.json()) 
// }
